import Highcharts from 'highcharts';

window.Highcharts = Highcharts;

import 'highcharts/modules/accessibility';
import 'highcharts/highcharts-more';
import 'highcharts/modules/exporting';
import 'highcharts/modules/no-data-to-display';
import 'highcharts/modules/solid-gauge';
import initRedrawRegression from "vendor/highcharts/redraw-regression";
import initHighchartsOverrides from "vendor/highcharts/highcharts-overrides";
import initRegression from "vendor/highcharts/regression";
import initSparkline from "vendor/highcharts/sparkline";
import 'highcharts/modules/drilldown';

initRedrawRegression(Highcharts);
initHighchartsOverrides(Highcharts);
initRegression(Highcharts);
initSparkline(Highcharts);

import 'highcharts/css/highcharts-palette.css';

import './highcharts.less';

export default {
	init: function () {
		//turn off Highcharts animation globally
		Highcharts.setOptions({
			plotOptions: {
				series: {
					animation: false,
				},
			},
			tooltip: {
				style: {
					fontSize: '1em',
				},
			},
			xAxis: {
				lineColor: '#ccd6eb',
			},
			palette: {
				colorScheme: 'light',
			},
		});
	},
};
